












import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class EcgIcon extends Vue {
  @Prop({ type: [String, Number], default: 24 }) size!: string | number
  @Prop({ type: String, default: '#ADAEBC' }) color!: string
}
